import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_PROVINCES = "GET_ALL_PROVINCES";
export const GET_CANTONES_BY_PROVINCE = "GET_CANTONES_BY_PROVINCE";
export const GET_DISTRITOS_BY_CANTON = "GET_DISTRITOS_BY_CANTON";
export const GET_LOCATION_BY_BADGE = "GET_LOCATION_BY_BADGE";
export const LOCA_LOADING = "LOCA_LOADING";
export const ADD_LOCATION = "ADD_LOCATION";
export const ADD_PROVINCE = "ADD_PROVINCE";
export const ADD_CANTON = "ADD_CANTON";
export const ADD_DISTRIC = "ADD_DISTRIC";

const instance = axios.create({
  baseURL: process.env.REACT_APP_AYB_API_URL,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllProvinces = () => {
  var Token = convertSHA()
  return async  dispatch =>{
    dispatch({
      type: LOCA_LOADING
    });
    await instance.get(`/Province/GetAllProvinces/${Token}`).then((res => {
        dispatch({
            type: GET_ALL_PROVINCES,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const getCantonesByProvince = (proid) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: LOCA_LOADING
      });
      await instance.get(`/Canton/GetCantonByProvinceId/${proid}&${Token}`).then((res => {
          dispatch({
              type: GET_CANTONES_BY_PROVINCE,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getDistritosByCanton = (canid) => {
    var Token = convertSHA()
    return  async  dispatch =>{
      dispatch({
        type: LOCA_LOADING
      });
      await instance.get(`/District/GetDistrictsByCantonId/${canid}&${Token}`).then((res => {
          dispatch({
              type: GET_DISTRITOS_BY_CANTON,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getLocationByBadge = (badge) => {
    var Token = convertSHA()
    return  async  dispatch =>{
      dispatch({
        type: LOCA_LOADING
      });
      await instance.get(`/UserLocation/GetUserLocationByBadge/${badge}&${Token}`).then((res => {
          dispatch({
              type: GET_LOCATION_BY_BADGE,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

export const addLocation = (id,badge,dis_id,lat,long,address) =>{
  var Token = convertSHA()
  const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
  let formData = new FormData();
  formData.append('address', address);
  formData.append('Token', Token);
     return async dispatch => {
        dispatch({
            type: LOCA_LOADING
          });
        //console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/UserLocation/PutInsUpdateUserLocation/${id}&${badge}&${dis_id}&${lat}&${long}&${badge}`, formData, config ).then((res => {
            dispatch({
                type: ADD_LOCATION,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}

export const addProvince = (id,name,lat,long,badge) =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: LOCA_LOADING
          });
        //console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/Province/PutInsUpdtProvince/${id}&${name}&${lat}&${long}&${badge}&${Token}` ).then((res => {
            dispatch({
                type: ADD_PROVINCE,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}

export const addCanton = (id,name,pro_id,lat,long,badge) =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: LOCA_LOADING
          });
        //console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/Canton/PutInsUpdtCanton/${id}&${name}&${pro_id}&${lat}&${long}&${badge}&${Token}` ).then((res => {
            dispatch({
                type: ADD_CANTON,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}
export const addDistric = (id,name,can_id,lat,long,zipCode,badge) =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: LOCA_LOADING
          });
        //console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/District/PutInsUpdtDistrict/${id}&${name}&${can_id}&${lat}&${long}&${zipCode}&${badge}&${Token}` ).then((res => {
            dispatch({
                type: ADD_DISTRIC,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}